import { useCallback } from 'react';
import { Capacitor } from '@capacitor/core';

import { useTranslation } from '@/utils/i18n';
import { STORE_URL_IOS, STORE_URL_ANDROID } from '@/constants';
import { openExternal } from '@/utils/browser';
import { PrimaryButton } from '@/components/Buttons';
import RacoreText from '@/components/Logos/RacoreText';

/**
 * Non-dismissible force-update overlay (#4). Rendered at the root in place of the
 * app when the running version is below the backend `mandatory_version`. There is
 * intentionally no close affordance — the only action is to open the store.
 */
export default function ForceUpdateScreen() {
  const { t } = useTranslation();

  const openStore = useCallback(() => {
    const url = Capacitor.getPlatform() === 'ios' ? STORE_URL_IOS : STORE_URL_ANDROID;
    void openExternal(url);
  }, []);

  return (
    <div
      className="tw:flex tw:h-full tw:w-full tw:flex-col tw:items-center tw:justify-center tw:gap-8 tw:px-8 tw:text-center"
      data-testid="screen-force-update"
    >
      <RacoreText width={140} height={30} />
      <div className="tw:flex tw:flex-col tw:gap-3">
        <h1 className="tw:heading-1 tw:text-white">{t('appUpdate.mandatory.title')}</h1>
        <p className="tw:text-base tw:text-grey-2">{t('appUpdate.mandatory.message')}</p>
      </div>
      <PrimaryButton
        label={t('appUpdate.updateButton')}
        onClick={openStore}
        data-testid="btn-force-update"
      />
    </div>
  );
}
